module.exports = __webpack_public_path__ + "static/img/HY-V2.2d4ca53b.png";